import {POST_RNH_NEW_NOTE, UPDATE_RNH_NOTE_DETAIL} from '../../../actions/actiontypes';
import {EngagementCommentStatus} from '../../../util/uiconstants';

export default (state, documentId, data, actionType, previousStatusId) => {
	if (state === null || state.data === null) return null;
	const mapRelatedDocuments = (document) => {
		if (documentId === document?.id) {
			let engagementReviewNoteCount = document?.engagementReviewNoteCount;
			if (actionType === POST_RNH_NEW_NOTE || (actionType === UPDATE_RNH_NOTE_DETAIL && data?.isOpening))
				engagementReviewNoteCount = engagementReviewNoteCount + 1;
			if (
				actionType === UPDATE_RNH_NOTE_DETAIL &&
				data?.isClosing &&
				previousStatusId === EngagementCommentStatus.open &&
				engagementReviewNoteCount > 0
			)
				engagementReviewNoteCount = engagementReviewNoteCount - 1;
			return {
				...document,
				engagementReviewNoteCount
			};
		} else return {...document};
	};

	const mapTechnology = (technology) => {
		return {
			...technology,
			relatedDocuments: technology?.relatedDocuments?.map(mapRelatedDocuments)
		};
	};

	const newState = {
		...state,
		data: state?.data?.map(mapTechnology)
	};

	return newState;
};
